import { PRESCRIPTION_STATUS } from '@abiglobalhealth/go-types'

import { FulfillmentChoiceSelection } from '@/components/Consultation/steps/WaitingForInfo/FulfillmentChoiceSelection'
import { PharmacySelector } from '@/components/Consultation/steps/WaitingForInfo/FulfillmentChoiceSelection/PharmacySelector'
import { UserAddressForm } from '@/components/Consultation/steps/WaitingForInfo/FulfillmentChoiceSelection/UserAddressForm'
import { PrescriptionPayment } from '@/components/Consultation/steps/WaitingForInfo/PrescriptionPayment'
import { ProcessingPrescription } from '@/components/Consultation/steps/WaitingForInfo/ProcessingPrescription'
import { usePrescription } from '@/hooks/usePrescription'

import { DeliveryForm } from './FulfillmentChoiceSelection/DeliveryForm'

export const WaitingForInfo = () => {
  const { prescription } = usePrescription()

  switch (prescription?.status) {
    case PRESCRIPTION_STATUS.WAITING_FOR_FULFILLMENT:
      return <FulfillmentChoiceSelection />

    case PRESCRIPTION_STATUS.PHARMACY_ASKED:
      return <PharmacySelector />

    case PRESCRIPTION_STATUS.PATIENT_ADDRESS_ASKED:
      return <UserAddressForm />

    case PRESCRIPTION_STATUS.WAITING_FOR_PAYMENT:
      return <PrescriptionPayment />

    case PRESCRIPTION_STATUS.PROCESSING:
    case PRESCRIPTION_STATUS.CREATED:
      return <ProcessingPrescription />

    case PRESCRIPTION_STATUS.DELIVERY_ADDRESS_ASKED:
      return <DeliveryForm />

    default:
      return (
        <span className="p-4 text-center">
          ERR - No <i>WaitingForInfo</i> screen for status &quot;{prescription?.status}&quot;
        </span>
      )
  }
}
